// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"PopupVideo_buttonWrapper__5wnkP","center":"PopupVideo_center__nyQTW","right":"PopupVideo_right__cNR5s"};